var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49998 17.225C7.65831 17.225 7.81664 17.1667 7.94164 17.0417L13.375 11.6084C14.2583 10.725 14.2583 9.27502 13.375 8.39168L7.94164 2.95835C7.69998 2.71668 7.29998 2.71668 7.05831 2.95835C6.81664 3.20002 6.81664 3.60002 7.05831 3.84168L12.4916 9.27502C12.8916 9.67502 12.8916 10.325 12.4916 10.725L7.05831 16.1583C6.81664 16.4 6.81664 16.8 7.05831 17.0417C7.18331 17.1584 7.34164 17.225 7.49998 17.225Z",
    fill: "#787486"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 17.225C13.6583 17.225 13.8166 17.1667 13.9416 17.0417L19.375 11.6084C20.2583 10.725 20.2583 9.27502 19.375 8.39168L13.9416 2.95835C13.7 2.71668 13.3 2.71668 13.0583 2.95835C12.8166 3.20002 12.8166 3.60002 13.0583 3.84168L18.4916 9.27502C18.8916 9.67502 18.8916 10.325 18.4916 10.725L13.0583 16.1583C12.8166 16.4 12.8166 16.8 13.0583 17.0417C13.1833 17.1584 13.3416 17.225 13.5 17.225Z",
    fill: "#787486"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShow);
export default __webpack_public_path__ + "static/media/Show.5d533e170dded52f9b2df607705a0b1b.svg";
export { ForwardRef as ReactComponent };